export default __webpack_public_path__ + "static/media/culture_EP20.b9afb64b.png";